import './_hatbox-product-options.scss';
import component from './hatbox-product-options';

export default component;
